import { render, staticRenderFns } from "./Genre.vue?vue&type=template&id=4b0c49a2"
import script from "./Genre.vue?vue&type=script&lang=js"
export * from "./Genre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b0c49a2')) {
      api.createRecord('4b0c49a2', component.options)
    } else {
      api.reload('4b0c49a2', component.options)
    }
    module.hot.accept("./Genre.vue?vue&type=template&id=4b0c49a2", function () {
      api.rerender('4b0c49a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/Genre.vue"
export default component.exports